import "./instrument.js";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import store from "./redux/state";
import App from "./App";
import { AuthProvider } from "./context/AuthProvider";
import FeatureFlagsProvider from "./context/FeatureFlagsProvider";
import AutoLoginLinkProvider from "./context/AutoLoginLinkProvider";
import ConversionParamsProvider from "./context/ConversionParamsProvider";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/i18n";
import ErrorBoundary from "./ErrorBoundary.jsx";
import { AzugaAttributionProvider } from "./AzugaAttributionProvider.jsx";
import { AnimationProvider } from "/context/AnimationProvider.jsx";
// import { GoogleOAuthProvider } from "@react-oauth/google";

const root = createRoot(document.getElementById("root"));

let rerenderEntireTree = () => {
  const state = store.getState();
  root.render(
    <>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={state.basePath}>
          <AzugaAttributionProvider />
          <ConversionParamsProvider>
            <AuthProvider>
              <AnimationProvider>
                <AutoLoginLinkProvider>
                  <FeatureFlagsProvider>
                    <ErrorBoundary>
                      <App state={store} />
                    </ErrorBoundary>
                  </FeatureFlagsProvider>
                </AutoLoginLinkProvider>
              </AnimationProvider>
            </AuthProvider>
          </ConversionParamsProvider>
        </BrowserRouter>
      </I18nextProvider>
    </>,
  );
};

rerenderEntireTree();
store.subscribe(rerenderEntireTree);
